export enum MENU_ACTIONS {
  DELIVERED = 1,
  PREPARE,
  SETTING
}
